export function resetFilterValues() {
    localStorage.removeItem("filterDateFrom");
    localStorage.removeItem("filterDateTo");
    localStorage.removeItem("filterRegionId");
    localStorage.removeItem("filterRegionName");
    localStorage.removeItem("filterCountryId");
    localStorage.removeItem("filterCountryName");
    localStorage.removeItem("filterCity");
    localStorage.removeItem("filterFeatures");
    localStorage.removeItem("filterOrderBy");
    localStorage.removeItem("filter-bedrooms-from");
    localStorage.removeItem("filter-bedrooms-to");

    resetPricePerNight();

    localStorage.setItem("filterCapacityMode", "min");
    localStorage.setItem("filterCapacity", "1");

    //Set Cesko as country while reseting
    /*
    let czechEl = document.getElementById("country_filter_item_1");
    let czechLabel;
    if(czechEl) {
        czechLabel = czechEl.innerHTML;
    } else {
        czechLabel = "Česko";
    }
    localStorage.setItem("filterCountryId", "1");
    localStorage.setItem("filterCountryName", czechLabel);*/
}

export function resetPricePerNightIfNotModified() {
    const pricePerNightMax = parseInt($("#pricePerNightMax").data("value"));
    if (!pricePerNightMax) {
        return;
    }

    const filterPriceTo = parseInt(localStorage.getItem("filter-pricePerNight-to"));
    if(pricePerNightMax !== filterPriceTo) {
        return;
    }

    const pricePerNightMin = parseInt($("#pricePerNightMin").data("value"));
    const filterPriceFrom = parseInt(localStorage.getItem("filter-pricePerNight-from"));

    if(pricePerNightMin !== filterPriceFrom) {
        return;
    }

    console.log("doing reset");

    resetPricePerNight();
}

export function resetPricePerNight() {
    localStorage.removeItem("filter-pricePerNight-from");
    localStorage.removeItem("filter-pricePerNight-to");
}